module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-2a-1d862c790d0fc6efc01dae03ed60f243.png";